import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@bn-apps/dim-ui-react';
import { ArrowUpwardAlt } from '@bn-apps/design-system-icons';
import styles from './ScrollToTopButton.module.scss';

const SCROLL_THRESHOLD = 600;

function ScrollToTopButton(): JSX.Element | null {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY > SCROLL_THRESHOLD);

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <Button
      type="button"
      variant="primary"
      size="sm"
      iconStart={ArrowUpwardAlt}
      className={styles.button}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      {t('common.scrollToTop')}
    </Button>
  );
}

export default ScrollToTopButton;